<template>
  <div class="business-params-pane">
    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      label-position="left"
      label-width="auto"
      size="medium"
      class="business-params-form"
    >
      <div class="section-title section-title--first">会员费配置</div>
      <el-row :gutter="20" class="business-params-grid">
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="普通会员认证费" prop="ordinaryMemberAuthFee" :required="true">
            <div class="field-flex">
              <div class="input-with-unit">
                <el-input-number
                  v-model="form.ordinaryMemberAuthFee"
                  :min="0"
                  :max="9999"
                  :step="0.01"
                  :precision="decimalPrecision"
                  controls-position="right"
                  style="width: 200px;"
                />
                <span class="unit">元</span>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="高级会员认证费" prop="advancedMemberAuthFee" :required="true">
            <div class="field-flex">
              <div class="input-with-unit">
                <el-input-number
                  v-model="form.advancedMemberAuthFee"
                  :min="0"
                  :max="9999"
                  :step="0.01"
                  :precision="decimalPrecision"
                  controls-position="right"
                  style="width: 200px;"
                />
                <span class="unit">元</span>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="section-title">个人与团队奖励系数配置</div>
      <el-row :gutter="20" class="business-params-grid">
        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="个人返佣奖励系数" prop="personalRefundCommissionRewardCoeff" :required="true">
            <div class="field-flex">
              <div class="input-with-unit">
                <el-input-number
                  v-model="form.personalRefundCommissionRewardCoeff"
                  :min="0"
                  :max="100"
                  :step="0.01"
                  :precision="decimalPrecision"
                  controls-position="right"
                  style="width: 200px;"
                />
                <span class="unit">%</span>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="团队返佣奖励系数" prop="teamRefundCommissionRewardCoeff" :required="true">
            <div class="field-flex">
              <div class="input-with-unit">
                <el-input-number
                  v-model="form.teamRefundCommissionRewardCoeff"
                  :min="0"
                  :max="100"
                  :step="0.01"
                  :precision="decimalPrecision"
                  controls-position="right"
                  style="width: 200px;"
                />
                <span class="unit">%</span>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item label="团队数据奖励系数" prop="teamDataRewardCoeff" :required="true">
            <div class="field-flex">
              <div class="input-with-unit">
                <el-input-number
                  v-model="form.teamDataRewardCoeff"
                  :min="0"
                  :max="100"
                  :step="0.01"
                  :precision="decimalPrecision"
                  controls-position="right"
                  style="width: 200px;"
                />
                <span class="unit">%</span>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item prop="personalDealRateBaseCoeff" :required="true">
            <template slot="label">
              <span class="label-text-green">个人成交率基础系数</span>
            </template>
            <div class="field-block">
              <div class="field-flex">
                <div class="input-with-unit">
                  <el-input-number
                    v-model="form.personalDealRateBaseCoeff"
                    :min="0"
                    :max="personalDealRateBaseMax"
                    :step="0.01"
                    :precision="decimalPrecision"
                    controls-position="right"
                    style="width: 200px;"
                    @change="syncDealRatePairValidate"
                  />
                  <span class="unit">%</span>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item prop="personalDealRateUpperCoeff" :required="true">
            <template slot="label">
              <span class="label-text-red">个人成交率上限系数</span>
            </template>
            <div class="field-block">
              <div class="field-flex">
                <div class="input-with-unit">
                  <el-input-number
                    v-model="form.personalDealRateUpperCoeff"
                    :min="personalDealRateUpperMin"
                    :max="100"
                    :step="0.01"
                    :precision="decimalPrecision"
                    controls-position="right"
                    style="width: 200px;"
                    @change="syncDealRatePairValidate"
                  />
                  <span class="unit">%</span>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="24" :md="12" :lg="6">
          <el-form-item prop="personalReferralRewardFixedCoeff" :required="true">
            <template slot="label">
              <span class="label-text-blue">个人推荐奖励固定系数</span>
            </template>
            <div class="field-flex">
              <div class="input-with-unit">
                <el-input-number
                  v-model="form.personalReferralRewardFixedCoeff"
                  :min="0"
                  :max="999999"
                  :step="0.01"
                  :precision="decimalPrecision"
                  controls-position="right"
                  style="width: 200px;"
                />
                <el-popover
                  placement="top-start"
                  width="880"
                  trigger="hover"
                  popper-class="referral-reward-popper"
                >
                  <div class="referral-reward-popover">
                    <p>
                      <h3>个人推荐有效数据奖励计算规则：</h3>
                    </p>
                    <p>
                      1、个人50条以内推荐奖励/条 = <span class="label-text-green">个人成交率基础系数</span> * <span class="label-text-blue">个人推荐奖励固定系数</span>；
                    </p>
                    <p>
                      2、超过50条部分推荐奖励/条 = 个人成交率（向下取整但不低于<span class="label-text-green">个人成交率基础系数</span>）* <span class="label-text-blue">个人推荐奖励固定系数</span>；
                    </p>
                    <p>
                      3、个人成交率大于<span class="label-text-red">个人成交率上限系数</span>时，推荐奖励/条 = <span class="label-text-red">个人成交率上限系数</span> * <span class="label-text-blue">个人推荐奖励固定系数</span>；
                    </p>
                  </div>
                  <span slot="reference" class="label-info-trigger" tabindex="0" role="button" aria-label="说明">
                    <i class="el-icon-info"></i>
                  </span>
                </el-popover>
              </div>
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-form-item class="form-actions">
        <el-button type="primary" @click="handleSave" :loading="saveLoading">保存</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import api from '@/services/api';

const DEFAULTS = {
  ordinaryMemberAuthFee: 20,
  advancedMemberAuthFee: 100,
  teamDataRewardCoeff: 10,
  personalRefundCommissionRewardCoeff: 25,
  teamRefundCommissionRewardCoeff: 5,
  personalDealRateBaseCoeff: 2,
  personalDealRateUpperCoeff: 100,
  personalReferralRewardFixedCoeff: 500
};

function numberOrNull(v) {
  if (v === null || v === undefined) return null;
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function validateRequiredRange(min, max) {
  return (rule, value, callback) => {
    const n = numberOrNull(value);
    if (n === null) return callback(new Error('必填'));
    if (n < min || n > max) return callback(new Error(`范围必须在 ${min} - ${max}`));
    callback();
  };
}

export default {
  name: 'BusinessParamsConfig',
  data() {
    return {
      saveLoading: false,
      decimalPrecision: 2,
      form: { ...DEFAULTS }
    };
  },
  computed: {
    personalDealRateBaseMax() {
      const u = numberOrNull(this.form.personalDealRateUpperCoeff);
      if (u === null) return 100;
      return Math.min(100, u);
    },
    personalDealRateUpperMin() {
      const b = numberOrNull(this.form.personalDealRateBaseCoeff);
      if (b === null) return 0;
      return Math.max(0, b);
    },
    rules() {
      const vm = this;
      return {
        ordinaryMemberAuthFee: [
          { required: true, validator: validateRequiredRange(0, 9999), trigger: ['change', 'blur'] }
        ],
        advancedMemberAuthFee: [
          { required: true, validator: validateRequiredRange(0, 9999), trigger: ['change', 'blur'] }
        ],
        teamDataRewardCoeff: [
          { required: true, validator: validateRequiredRange(0, 100), trigger: ['change', 'blur'] }
        ],
        personalRefundCommissionRewardCoeff: [
          { required: true, validator: validateRequiredRange(0, 100), trigger: ['change', 'blur'] }
        ],
        teamRefundCommissionRewardCoeff: [
          { required: true, validator: validateRequiredRange(0, 100), trigger: ['change', 'blur'] }
        ],
        personalDealRateBaseCoeff: [
          {
            required: true,
            validator(rule, value, callback) {
              const n = numberOrNull(value);
              if (n === null) return callback(new Error('必填'));
              if (n < 0 || n > 100) return callback(new Error('范围必须在 0 - 100'));
              const u = numberOrNull(vm.form.personalDealRateUpperCoeff);
              if (u !== null && n > u) return callback(new Error('须小于等于个人成交率上限系数'));
              callback();
            },
            trigger: ['change', 'blur']
          }
        ],
        personalDealRateUpperCoeff: [
          {
            required: true,
            validator(rule, value, callback) {
              const n = numberOrNull(value);
              if (n === null) return callback(new Error('必填'));
              if (n < 0 || n > 100) return callback(new Error('范围必须在 0 - 100'));
              const b = numberOrNull(vm.form.personalDealRateBaseCoeff);
              if (b !== null && n < b) return callback(new Error('须大于等于个人成交率基础系数'));
              callback();
            },
            trigger: ['change', 'blur']
          }
        ],
        personalReferralRewardFixedCoeff: [
          { required: true, validator: validateRequiredRange(0, 999999), trigger: ['change', 'blur'] }
        ]
      };
    }
  },
  mounted() {
    this.load();
  },
  methods: {
    syncDealRatePairValidate() {
      this.$nextTick(() => {
        const ref = this.$refs.formRef;
        if (!ref) return;
        ref.validateField('personalDealRateBaseCoeff');
        ref.validateField('personalDealRateUpperCoeff');
      });
    },
    async load() {
      try {
        const res = await api.post('/system/business-params-config/query', {});
        if (res.data && res.data.success) {
          const d = res.data.data || {};
          this.form = {
            ordinaryMemberAuthFee: Number.isFinite(Number(d.ordinaryMemberAuthFee)) ? Number(d.ordinaryMemberAuthFee) : DEFAULTS.ordinaryMemberAuthFee,
            advancedMemberAuthFee: Number.isFinite(Number(d.advancedMemberAuthFee)) ? Number(d.advancedMemberAuthFee) : DEFAULTS.advancedMemberAuthFee,
            teamDataRewardCoeff: Number.isFinite(Number(d.teamDataRewardCoeff)) ? Number(d.teamDataRewardCoeff) : DEFAULTS.teamDataRewardCoeff,
            personalRefundCommissionRewardCoeff: Number.isFinite(Number(d.personalRefundCommissionRewardCoeff))
              ? Number(d.personalRefundCommissionRewardCoeff)
              : DEFAULTS.personalRefundCommissionRewardCoeff,
            teamRefundCommissionRewardCoeff: Number.isFinite(Number(d.teamRefundCommissionRewardCoeff))
              ? Number(d.teamRefundCommissionRewardCoeff)
              : DEFAULTS.teamRefundCommissionRewardCoeff,
            personalDealRateBaseCoeff: Number.isFinite(Number(d.personalDealRateBaseCoeff))
              ? Number(d.personalDealRateBaseCoeff)
              : DEFAULTS.personalDealRateBaseCoeff,
            personalDealRateUpperCoeff: Number.isFinite(Number(d.personalDealRateUpperCoeff))
              ? Number(d.personalDealRateUpperCoeff)
              : DEFAULTS.personalDealRateUpperCoeff,
            personalReferralRewardFixedCoeff: Number.isFinite(Number(d.personalReferralRewardFixedCoeff))
              ? Number(d.personalReferralRewardFixedCoeff)
              : DEFAULTS.personalReferralRewardFixedCoeff
          };
        }
      } catch (e) {
        // 保持默认值即可
      }
    },
    async handleSave() {
      this.$refs.formRef.validate(async (valid) => {
        if (!valid) return;
        this.saveLoading = true;
        try {
          await api.post('/system/business-params-config', { ...this.form });
          this.$message.success('保存成功');
          await this.load();
        } catch (e) {
          this.$message.error(e.response?.data?.message || '保存失败');
        } finally {
          this.saveLoading = false;
        }
      });
    }
  }
};
</script>

<style scoped>
.business-params-pane {
  padding: 24px;
  width: 100%;
}

.business-params-form {
  width: 100%;
}

.section-title {
  margin: 0 0 16px;
  padding-top: 2px;
  font-size: 16px;
  font-weight: 800;
  color: #409EFF;
  border-top: 1px solid rgba(60, 60, 67, 0.12);
}

.section-title--first {
  border-top: none;
  padding-top: 0;
}


.business-params-form >>> .el-form-item__label {
  white-space: nowrap;
}

.business-params-form >>> .el-form-item__content {
  display: flex;
  align-items: center;
  min-height: 32px;
}

.field-block {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
}

.field-flex {
  display: flex;
  align-items: center;
}

.input-with-unit {
  display: flex;
  align-items: center;
  gap: 8px;
}

.unit {
  color: #909399;
  font-size: 14px;
  white-space: nowrap;
}

.form-tip {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
  line-height: 1.4;
  width: 100%;
}

.form-actions {
  margin-top: 16px;
}

.label-text-red {
  color: #f56c6c;
}

.label-text-green {
  color: #67c23a;
}

.label-text-blue {
  color: #53a8ff;
}

.label-info-trigger {
  display: inline-flex;
  align-items: center;
  color: #53a8ff;
  cursor: help;
  outline: none;
}

.label-info-trigger:hover,
.label-info-trigger:focus {
  color: #53a8ff;
}

.referral-reward-popover p {
  margin: 0 0 10px;
  line-height: 1.55;
  font-size: 13px;
  color: #606266;
}

.referral-reward-popover p:last-child {
  margin-bottom: 0;
}
</style>

<style>
.referral-reward-popper .referral-reward-popover .label-text-green {
  color: #67c23a;
}

.referral-reward-popper .referral-reward-popover .label-text-red {
  color: #f56c6c;
}

.referral-reward-popper .referral-reward-popover .label-text-blue {
  color: #53a8ff;
}
</style>
